module.exports = __webpack_public_path__ + "static/bg-wedding-92e27a610c89594d371335aaff06052a.jpg";